export default "__VITE_ASSET__CiJJhAjM__"